import { helmetJsonLdProp } from 'react-schemaorg';

const schemaOrg = (retailer) => {
  // TODO Multistore
  const primaryStore = retailer.stores[0]
  return [
    helmetJsonLdProp({
      '@context': 'https://schema.org',
      name: retailer.retailer_name,
      '@type': 'JewelryStore',
      telephone: primaryStore.phone_number,
      address: {
        '@type': 'PostalAddress',
        streetAddress: primaryStore.street,
        addressLocality: primaryStore.city,
        postalCode: primaryStore.zip,
        // TODO get from API
        addressCountry: 'DE',
      },
      // TODO optimize
      openingHoursSpecification: function() {
        const hoursSepc = [];
        primaryStore.opening_hours.forEach(hour => hour.is_open && hoursSepc.push({
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: hour.day,
          opens: hour.start_time_1,
          closes: hour.end_time_1,
        }))
        return hoursSepc;
      }(),
      // url: '',
    })
  ]
}

export default schemaOrg;